export let PhoneUtility = {
    dbPhoneToUsersListDisplayPhone: function (phoneNumber: string) {
        if (phoneNumber) {
            if (phoneNumber.startsWith('+1')) {
                phoneNumber = phoneNumber.slice(2);
            }

            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        } else {
            return null;
        }
    },

    dbPhoneToParenthesesDisplayPhone: function (phoneNumber?: string | null) {
        if (phoneNumber) {
            if (phoneNumber.startsWith('+1')) {
                phoneNumber = phoneNumber.slice(2);
            }

            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        } else {
            return null;
        }
    }
}
